export default "__VITE_ASSET__24c2271d__"